module.exports = __webpack_public_path__ + "static/post-assessment-8ddb1a0dd5b73f46d86fa946b3aa6d15.png";